import { Injectable } from '@angular/core';
import { WorkorderDeclinedMpviCode } from '@quorum/models/xs-resource';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  GetWorkOrderDeclinedOperationsFromServer,
  GetWorkOrderDeclinedOperationsFromServerSuccess,
  WorkOrderDeclinedOperationsEntityActionTypes,
  CreateWorkOrderDeclinedOperationsOnServer,
  CreateWorkOrderDeclinedOperationsOnServerSuccess,
  DeleteWorkOrderDeclinedOperationFromServer,
  DeleteWorkOrderDeclinedOperationFromServerSuccess,
  UpdateWorkOrderDeclinedOperationOnServer,
  UpdateWorkOrderDeclinedOperationOnServerSuccess,
} from './work-order-declined-operations.actions';

@Injectable()
export class WorkOrderDeclinedOperationsEntityEffects {
  
  getWorkOrderDeclinedOperationsFromServer = createEffect(() => this.dataPersistence.fetch(
    WorkOrderDeclinedOperationsEntityActionTypes.GetWorkOrderDeclinedOperationsFromServer,
    {
      run: (action: GetWorkOrderDeclinedOperationsFromServer, state: any) => {
        return this.apiService
          .get<WorkorderDeclinedMpviCode[]>(`v/1/fixed-operations/work-order-declined-mpvi-codes`, {
            params: action.payload,
          })
          .pipe(
            map((WorkOrderDeclinedOperations) => {
              return new GetWorkOrderDeclinedOperationsFromServerSuccess(WorkOrderDeclinedOperations);
            })
          );
      },
      onError: (action: GetWorkOrderDeclinedOperationsFromServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  
  createWorkOrderDeclinedOperationsOnServer = createEffect(() => this.dataPersistence.fetch(
    WorkOrderDeclinedOperationsEntityActionTypes.CreateWorkOrderDeclinedOperationsOnServer,
    {
      run: (action: CreateWorkOrderDeclinedOperationsOnServer, state: any) => {
        return this.apiService
          .post<WorkorderDeclinedMpviCode>(`v/1/fixed-operations/work-order-declined-mpvi-codes`, action.payload)
          .pipe(
            map(
              (declinedService: WorkorderDeclinedMpviCode) =>
                new CreateWorkOrderDeclinedOperationsOnServerSuccess(declinedService)
            )
          );
      },
      onError: (action: CreateWorkOrderDeclinedOperationsOnServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  
  deleteWorkOrderDeclinedOperationFromServer = createEffect(() => this.dataPersistence.pessimisticUpdate(
    WorkOrderDeclinedOperationsEntityActionTypes.DeleteWorkOrderDeclinedOperationFromServer,
    {
      run: (action: DeleteWorkOrderDeclinedOperationFromServer, state: any) => {
        return this.apiService
          .delete<WorkorderDeclinedMpviCode>(
            `v/1/fixed-operations/work-order-declined-mpvi-codes/${action.payload.id}`,
            action.payload
          )
          .pipe(
            map(
              (declinedService: WorkorderDeclinedMpviCode) =>
                new DeleteWorkOrderDeclinedOperationFromServerSuccess(declinedService)
            )
          );
      },
      onError: (action: DeleteWorkOrderDeclinedOperationFromServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  
  updateWorkOrderDeclinedOperationOnServer = createEffect(() => this.dataPersistence.pessimisticUpdate(
    WorkOrderDeclinedOperationsEntityActionTypes.UpdateWorkOrderDeclinedOperationOnServer,
    {
      run: (action: UpdateWorkOrderDeclinedOperationOnServer, state: any) => {
        return this.apiService
          .put<WorkorderDeclinedMpviCode>(
            `v/1/fixed-operations/work-order-declined-mpvi-codes/${action.payload.id}`,
            action.payload
          )
          .pipe(
            map(
              (declinedService: WorkorderDeclinedMpviCode) =>
                new UpdateWorkOrderDeclinedOperationOnServerSuccess(declinedService)
            )
          );
      },
      onError: (action: UpdateWorkOrderDeclinedOperationOnServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  constructor(private dataPersistence: DataPersistence<any>, private apiService: ApiService) {}
}
